import React, {
  useState,
  useEffect
} from 'react';

import GAException from 'src/components/GAException';
import Cookies from 'js-cookie';
import {
  Box,
  Button,
  Link,
  Portal,
  Typography,
  makeStyles,
  Icon
} from '@material-ui/core';
import { Close } from '@material-ui/icons';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white, //theme.palette.primary.main
    color: theme.palette.primary.main, //theme.palette.common.white
    maxWidth: 600,
    position: 'fixed',
    bottom: 0,
    left: 0,
    margin: theme.spacing(3),
    padding: theme.spacing(3),
    outline: 'none',
    zIndex: 2000,
    borderRadius: '24px',

  },
  action: {
    backgroundColor: theme.palette.primary.main, //theme.palette.primary.main
    color: theme.palette.common.white, //theme.palette.common.white
    borderRadius: '24px',
  },
   buttonClose: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    '&:hover': {
      opacity: 0.5,
      cursor: 'pointer'
    },
  },

}));

function CookiesNotification() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    Cookies.set('consent', 'true');
    setOpen(false);
  };

  useEffect(() => {
    const consent = Cookies.get('consent');

   if ((!consent || consent === 'false') && !window.ReactNativeWebView) {
      // Cookies.set('consent', 'true');//Seteamos por defecto las Cookies como consentidas
      setOpen(true);
      // console.log('Cookies notification');
    }else{
      setOpen(false);
    }
    if(window.ReactNativeWebView){
      Cookies.set('consent', 'true');
      setOpen(false);
    }


  }, []);

  if (!open || window.ReactNativeWebView)  {
    return null;
  }

  return (
    <Portal>
      <div className={classes.root}>
         <Box className={classes.buttonClose} onClick={() => setOpen(false)}>
          <Close />
        </Box>

        <Typography
          variant="body1"
          color="inherit"
        >
          Estamos usando Cookies para asegurarnos que tengas la mejor experiencia con DIMO.
          Lee nuestra politica de seguridad.
          {' '}
          <Link
            component="a"
            color="inherit"
            underline="always"
            href="/privacidad"
            target="_blank"
          >
            Privacy Policy
          </Link>
        </Typography>
        <Box
          mt={2}
          display="flex"
          justifyContent="flex-end"
        >
          <Button
            onClick={handleClose}
            variant="contained"
            className={classes.action}
          >
            Estoy de acuerdo
          </Button>
        </Box>
      </div>
    </Portal>
  );
}

export default CookiesNotification;
